/**
 * Copyright (C) Radiojar S.A. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 * Created by Danilo Venturini on 07/04/2022.
 */

export default {
	state: {
		seguePreviousEvent: null,
		segueCurrentEvent: null,
		segueNextEvent: null,
		currentlyPlaying: null,
		copiedEvent: null,
		cuttingEvent: null,
		resolveTagText: null
	},

	getters: {
		getSeguePreviousEvent: (state) => () => {
			return state.seguePreviousEvent;
		},
		getSegueCurrentEvent: (state) => () => {
			return state.segueCurrentEvent;
		},
		getSegueNextEvent: (state) => () => {
			return state.segueNextEvent;
		},
		getCurrentlyPlaying: (state) => () => {
			return state.currentlyPlaying;
		},
		getCopiedEvent: (state) => () => {
			return state.copiedEvent;
		},
		getCuttingEvent: (state) => () => {
			return state.cuttingEvent;
		},
		getResolveTagText: (state) => () => {
			return state.resolveTagText;
		}
	},

	mutations: {
		setSegueEvents(state, events) {
			state.seguePreviousEvent = events[0];
			state.segueCurrentEvent = events[1];
			state.segueNextEvent = events[2];
		},
		setCurrentlyPlaying(state, index) {
			state.currentlyPlaying = index;
		},
		setCopiedEvent(state, event) {
			state.copiedEvent = event;
		},
		setCuttingEvent(state, event) {
			state.cuttingEvent = event;
		},
		setResolveTagText(state, text) {
			state.resolveTagText = text;
		}
	},

	actions: {
		loadSegueEvents({commit}, events) {
			commit("setSegueEvents", events);
		},
		loadCurrentlyPlaying({commit}, eventIndex) {
			commit("setCurrentlyPlaying", eventIndex);
		}
	}
};
